import authService from '../../../services/auth';
import mixin from "../../../mixins/mixin";

export default {
  data() {
    return {
      user: {
        email: null,
      },
      smallLoading: false
    };
  },
  components: {
    VLoading : require('components/loading/loading.vue'),
  },
  mixins: [mixin],
  methods: {
    submit_reset(user) {
      this.smallLoading = true;
      authService.submitReset(this, user);
    },
  },
  mounted() {
    mixpanel.track('web.forgotpwd');
  }
};



// WEBPACK FOOTER //
// ./src/app/pages/password/index/index.js